import { Currency } from '~/Api/Currency';
import mapRatesSettings from '~/Api/User/ProductGroup/ExchangeRatesSettings/mapRatesSettings';

import ExchangeRates from './ExchangeRates';

export interface RawExchangeRates {
	settings: any;
	availableCurrencies: { code: string }[];
}

export default function mapExchangeRates(exchangeRates: RawExchangeRates): ExchangeRates {
	return new ExchangeRates(
		mapRatesSettings(exchangeRates.settings),
		exchangeRates.availableCurrencies.map((currency) => new Currency(currency.code))
	);
}
